import type { VoidComponent } from "solid-js";
import { createSignal, Show } from "solid-js";
import { TextAndIconButton } from "../../../components/button/Button";
import { makeTimer } from "@solid-primitives/timer";
import { COPY_SUCCESS_MESSAGE_DURATION_MS } from "../../../constants";
import { useTranslation } from "../../../state/i18n";

type CopyValueButtonProps = {
  value: string;
};
const CopyValueButton: VoidComponent<CopyValueButtonProps> = (props) => {
  const { t } = useTranslation();
  const [isCopying, setIsCopying] = createSignal(false);

  return (
    <Show
      when={!isCopying()}
      fallback={
        <TextAndIconButton
          variant="secondary"
          text={t(($) => $.COPY_VALUE_BUTTON_COPY_SUCCESS)}
          icon="check"
          disabled
        />
      }
    >
      <TextAndIconButton
        variant="secondary"
        text={t(($) => $.COPY_VALUE_BUTTON_COPY)}
        icon="duplicate"
        onClick={() => {
          navigator.clipboard.writeText(props.value).then(() => {
            setIsCopying(true);
            const dispose = makeTimer(
              () => {
                setIsCopying(false);
                dispose();
              },
              COPY_SUCCESS_MESSAGE_DURATION_MS,
              setTimeout,
            );
          });
        }}
      />
    </Show>
  );
};

export default CopyValueButton;
